"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fetchApi_1 = __importDefault(require("../../rest/fetchApi"));
var customLessonsApi_1 = require("../mock/customLessonsApi");
var customContentServiceUrl = process.env.CB_CUSTOM_CONTENT_SERVICE_SERVER_URL;
var CustomLessonsAPIs = {
    getLessonByUuid: function (token, uuid) {
        return fetchApi_1.default.get({
            mockFunc: customLessonsApi_1.getCustomLessonByUuid,
            url: "".concat(customContentServiceUrl, "/lessons/").concat(uuid),
            token: token,
        });
    },
    createCustomLesson: function (token, body) {
        return fetchApi_1.default.post({
            mockFunc: customLessonsApi_1.createCustomLesson,
            url: "".concat(customContentServiceUrl, "/lessons"),
            body: body,
            token: token,
        });
    },
    updateCustomLesson: function (token, _a) {
        var uuid = _a.uuid, body = __rest(_a, ["uuid"]);
        return fetchApi_1.default.put({
            mockFunc: customLessonsApi_1.updateCustomLesson,
            url: "".concat(customContentServiceUrl, "/lessons/").concat(uuid),
            body: body,
            token: token,
        });
    },
    getAllCustomLessonIcons: function (token) {
        return fetchApi_1.default.get({
            mockFunc: customLessonsApi_1.getAllCustomLessons,
            url: "".concat(customContentServiceUrl, "/custom_lessons_icons"),
            token: token,
        });
    },
    getCustomLessonDefaultIcon: function (token) {
        return fetchApi_1.default.get({
            mockFunc: customLessonsApi_1.getAllCustomLessons,
            url: "".concat(customContentServiceUrl, "/custom_lessons_default_icon"),
            token: token,
        });
    },
    getLessonUrl: function (token, uuid, preview) {
        if (preview === void 0) { preview = false; }
        return fetchApi_1.default.get({
            mockFunc: function () { return ({ lessonUrl: '' }); },
            url: "".concat(customContentServiceUrl, "/lesson_url/").concat(uuid, "?preview=").concat(preview),
            token: token,
        });
    },
    getUploadUrl: function (token, uuid) {
        var url = uuid ? "".concat(customContentServiceUrl, "/upload_lesson/").concat(uuid) : "".concat(customContentServiceUrl, "/upload_lesson/");
        return fetchApi_1.default.get({
            mockFunc: customLessonsApi_1.uploadLesson,
            url: url,
            token: token,
        });
    },
    uploadZip: function (signedUrl, zipFile) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, fetch("".concat(process.env.NODE_ENV === 'development' ? customContentServiceUrl : '').concat(signedUrl), {
                    method: 'PUT',
                    body: new Blob([zipFile], { type: 'application/zip' }),
                })];
        });
    }); },
    isLessonUnzipped: function (token, uuid) {
        var url = "".concat(customContentServiceUrl, "/is_lesson_unzipped/").concat(uuid);
        return fetchApi_1.default.get({
            mockFunc: customLessonsApi_1.lessonUnzipped,
            url: url,
            token: token,
        });
    },
};
exports.default = CustomLessonsAPIs;
